import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

/* C4: no auth screen is a dead end — always a visible way out. */
export const AuthCloseButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <button
      type="button"
      data-testid="auth-close-button"
      aria-label={t("common.close")}
      onClick={() => (window.history.length > 1 ? navigate(-1) : navigate("/"))}
      className="absolute top-6 right-6 h-10 w-10 rounded-full flex items-center justify-center text-[#0A0A0A]/40 hover:text-[#0A0A0A] hover:bg-black/5 transition-colors duration-200"
    >
      <X className="w-5 h-5" aria-hidden="true" />
    </button>
  );
};
